import request from "./request";

export async function getSSID() {
  const ssid = await request(`/sts`);
  return ssid;
}

export const fetchAndDownloadFile = async (url, onFailure) => {
  const response = await fetch(url);
  if (!response.ok) {
    onFailure?.();
    return;
  }
  const blob = await response.blob();
  const objectUrl = URL.createObjectURL(blob);
  const filename = url.split("?")[0].split("/").pop() || "download";
  const a = document.createElement("a");
  a.href = objectUrl;
  a.download = filename;
  a.click();
  URL.revokeObjectURL(objectUrl);
};

export const openDownloadWindow = async (cert, userId, isCustom, onNotFound) => {
  const courseId = cert.courseId || String(cert.id).replace(/^cc_/, "");
  const filename = cert.fileName || cert.certificateFile;
  const ssid = await getSSID();
  const custom = /^cc_/.test(cert.id) || cert.isCustom || cert.type === "custom" || isCustom ? "&custom=true" : "";
  const url = `${process.env.REACT_APP_API_URL}/files/${userId}/download/${courseId}/${filename}?ssid=${ssid}${custom}`;
  await fetchAndDownloadFile(url, onNotFound);
};

export const openAllDownloadWindow = async (userId) => {
  const ssid = await getSSID();
  window.open(`${process.env.REACT_APP_API_URL}/files/${userId}/download/all?ssid=${ssid}`, "_blank");
};

export const openExportWindow = async (courseId, userId, onError) => {
  const ssid = await getSSID();
  const url = `${process.env.REACT_APP_API_URL}/files/${userId}/export/${courseId}?ssid=${ssid}`;
  await fetchAndDownloadFile(url, onError);
};

export const goToCourse = async (courseId, userId) => {
  const { url } = await request.post(`/courses/${courseId}/moodle/enrol/users/${userId}`);
  return url;
};
